module.exports = __webpack_public_path__ + "static/img/chanta (4).faf8ca9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (4).jpg
// module id = NXlQ
// module chunks = 0